import { FormControlLabel } from "@mui/material";
import styled from "styled-components";

export const CheckboxStyled = styled(FormControlLabel)`
  .css-4sqru2-MuiButtonBase-root-MuiCheckbox-root {
    padding: 0 10px 0 0;
  }
`;
